import type { AppPage } from "../types";

export const FX_MOBILE_DOCK: { page: AppPage; label: string }[] = [
  { page: "dashboard", label: "Accueil" },
  { page: "clients", label: "Clients" },
  { page: "invoices", label: "Factures" },
  { page: "quotes", label: "Devis" },
];

export function fxMobileDocked(page: AppPage): boolean {
  return FX_MOBILE_DOCK.some((item) => item.page === page);
}
